import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FAQ() {
  const faqs = [{
    q: '¿Sirve si nunca trabajé en herrería?',
    a: 'Sí. El Módulo 1 arranca desde cero con el sistema paso a paso pensado para el contexto del taller argentino. No necesitás experiencia previa ni herramientas especiales para empezar.'
  }, {
    q: '¿Cómo recibo el material?',
    a: 'Acceso inmediato después del pago. Todo en formato digital, optimizado para celular, tablet y computadora. Lo tenés en menos de 5 minutos.'
  }, {
    q: '¿El Nivel Maestro es necesario?',
    a: 'Si ya tenés experiencia y querés escalar tu taller económicamente — sí, es el paso lógico. Si estás empezando desde cero, el Megapack base es el punto de partida ideal.'
  }, {
    q: '¿Cuánto tiempo lleva?',
    a: 'Podés aplicar el primer módulo en tu taller el mismo día que lo recibís. No es un curso para estudiar — es material práctico para hacer.'
  }, {
    q: '¿La garantía es real?',
    a: '100% real. Menos del 1% de devoluciones habla por sí solo. Si no te sirve, te devolvemos todo sin preguntas.'
  }, {
    q: '¿Aplica a la realidad argentina?',
    a: 'Todo el contenido está pensado para el taller argentino — materiales locales, medidas métricas, precios de mercado nacional y contexto real.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 bg-black" data-id="element-47">
      <div className="container mx-auto px-4 max-w-3xl" data-id="element-48">
        <h2 className="text-3xl font-extrabold text-center text-white mb-12" data-id="element-49">
          ❓ PREGUNTAS FRECUENTES
        </h2>

        <div className="space-y-4" data-id="element-50">
          {faqs.map((faq, i) => <div key={i} className="border border-amber-900/40 rounded-2xl overflow-hidden bg-zinc-900/60" data-id="element-51">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full px-6 py-5 text-left flex items-center justify-between focus:outline-none focus-visible:ring-2 focus-visible:ring-amber-400 hover:bg-zinc-900/40 transition-colors" aria-expanded={openIndex === i} data-id="element-52">
                <span className="font-bold text-white pr-4" data-id="element-53">{faq.q}</span>
                <ChevronDown className={`w-5 h-5 text-amber-300 transition-transform duration-300 shrink-0 ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-54" />
              </button>

              <AnimatePresence data-id="element-55">
                {openIndex === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-56">
                    <div className="px-6 pb-5 text-zinc-200 leading-relaxed border-t border-amber-900/30 pt-3" data-id="element-57">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}